export enum AirbnbGuestRequirements {
  EVERYONE = 'EVERYONE',
  WELL_REVIEWED_GUESTS = 'WELL_REVIEWED_GUESTS',
  OFF = 'OFF',
}
